import { onCLS, onFCP, onFID, onLCP, onTTFB } from 'web-vitals';
import { onResourceSize } from './metrics/resource-size';
export const WebVitalsCollector = (collector) => {
    const queue = new Set();
    function addToQueue(metric) {
        queue.add(metric);
    }
    function flushQueue() {
        if (queue.size > 0) {
            collector(queue);
            queue.clear();
        }
    }
    onFCP(addToQueue);
    // Consider using attribution build to pinpoint largest CLS, especially in SPAs
    onCLS(addToQueue);
    onLCP(addToQueue);
    onTTFB(addToQueue);
    // may not be available if user doesn't interact with the page
    onFID(addToQueue);
    // Report all available metrics whenever the page is backgrounded or unloaded.
    addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            flushQueue();
        }
    });
    // NOTE: Safari does not reliably fire the `visibilitychange` event when the
    // page is being unloaded. If Safari support is needed, you should also flush
    // the queue in the `pagehide` event.
    addEventListener('pagehide', flushQueue);
    onResourceSize(addToQueue);
};
//# sourceMappingURL=webvitals.js.map